import useTranslation from '@/utils/hooks/translation/useTranslation';

// Components
import { DatepickerDeadline } from '@/components/pages/giveaway-picker/OptionsWrapper/components/Deadline/DatePickerDeadline';

export const DateSection = () => {
    const { t } = useTranslation('giveaway_picker');

    return (
        <span className="z-20 w-full sm:w-1/3">
            <span className="mb-1.5 inline-block font-GMedium text-xs text-icoGray-400">
                {t('options.deadline_group.select_date')}
            </span>
            <DatepickerDeadline />
        </span>
    );
};
